'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchMain = /** @class */function () {
    function SearchMain() {
        this.searchBoxDom = document.getElementById('search');
        this.softwareBoxDom = document.getElementById('software');
        this.init();
    }
    SearchMain.prototype.init = function () {
        this.handleSearch();
        this.handleDownload();
        this.createAppQrcode();
    };
    SearchMain.prototype.handleSearch = function () {
        var inputBox = _tool2.default.$_select(this.searchBoxDom, '.help-input-box');
        var inputImgBox = _tool2.default.$_select(this.searchBoxDom, '.input-img-box');
        var inputDom = _tool2.default.$_select(this.searchBoxDom, '.search-input');
        var inputIcon = _tool2.default.$_select(this.searchBoxDom, '.input-icon');
        var searchBtn = _tool2.default.$_select(this.searchBoxDom, '.search-btn');
        var cloneInputValueDom = _tool2.default.$_select(this.searchBoxDom, '.clone-input-value');
        var isSelectText = false;
        var timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                cloneInputValueDom.innerText = inputVal;
            } else {
                cloneInputValueDom.innerText = 'Please enter keywords to search';
            }
        }, 50);
        inputBox.addEventListener('click', function (e) {
            inputDom.focus();
            inputIcon.classList.add('hide');
            searchBtn.classList.add('show');
            inputDom.classList.add('add-width');
            inputImgBox.classList.add('add-width');
            cloneInputValueDom.classList.add('hide');
            var inputVal = inputDom.value.trim();
            if (inputVal == '') {
                cloneInputValueDom.innerText = '';
            }
            var target = e.target;
            if (inputVal != '') {
                searchBtn.classList.add('active');
            } else {
                searchBtn.classList.remove('active');
            }
            if (searchBtn.contains(target)) {
                if (inputVal != '') {
                    window.open("/searchResult?keywords=".concat(inputVal, "&tab=course&page=1"));
                } else {
                    alert('The content of the input box cannot be empty.');
                }
            }
            e.stopPropagation();
        });
        inputDom.addEventListener('keyup', function (event) {
            var e = event || window.event;
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                searchBtn.classList.add('active');
                if (e.keyCode === 13) {
                    window.open("/searchResult?keywords=".concat(inputVal, "&tab=course&page=1"));
                }
            } else {
                searchBtn.classList.remove('active');
                if (e.keyCode === 13) {
                    alert('The content of the input box cannot be empty.');
                }
            }
        });
        inputDom.addEventListener('select', function () {
            isSelectText = true;
        });
        document.addEventListener('click', function () {
            var timer;
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (!isSelectText) {
                    inputIcon.classList.remove('hide');
                    searchBtn.classList.remove('show');
                    inputDom.classList.remove('add-width');
                    inputImgBox.classList.remove('add-width');
                    cloneInputValueDom.classList.remove('hide');
                    var inputVal = inputDom.value.trim();
                    if (inputVal != '') {
                        cloneInputValueDom.innerText = inputVal;
                    } else {
                        cloneInputValueDom.innerText = 'Please enter keywords to search';
                    }
                }
                isSelectText = false; // 回到初始状态
            }, 50);
        });
    };
    SearchMain.prototype.handleDownload = function () {
        var that = this;
        var downloadDom = _tool2.default.$_selectAll(that.softwareBoxDom, '.recommend-download');
        downloadDom.forEach(function (item) {
            item.addEventListener('click', function (e) {
                if (!item.classList.contains('active')) {
                    downloadDom.forEach(function (dItem) {
                        return dItem.classList.remove('active');
                    });
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
                e.stopPropagation();
            });
        });
        document.addEventListener('click', function () {
            downloadDom.forEach(function (dItem) {
                return dItem.classList.remove('active');
            });
        });
    };
    //循环生成app下载二维码
    SearchMain.prototype.createAppQrcode = function () {
        var that = this;
        var appCodeListDom = _tool2.default.$_selectAll(that.softwareBoxDom, '.qr-code-img');
        appCodeListDom.forEach(function (item) {
            var _val = item.getAttribute('data-dUrl');
            createQrcode(item, _val);
        });
    };
    return SearchMain;
}();
exports.default = SearchMain;